import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  padding-bottom: 50px;
`;

const PaddingContainer = styled.div`
  width: auto;
  margin-left: auto;
  margin-right: auto;
  max-width: 1280px;
`;

interface KurgoContainerProps {
  children: React.ReactNode;
  backgroundColor?: string;
}

const KurgoContainer = ({
  children,
  backgroundColor = 'transparent',
}: KurgoContainerProps) => (
  <PageContainer backgroundColor={backgroundColor}>
    <PaddingContainer>{children}</PaddingContainer>
  </PageContainer>
);

export default KurgoContainer;
